import { AppProvider } from "./context";
import Header from "./components/Header";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Dishes from "./components/Dishes";
import Gallery from "./components/Gallery";
import Footer from "./components/Footer";
import DishDetail from "./components/DishDetail";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

function App() {
  return (
    <AppProvider>
      <Router>
        <main className="main">
          <Header />
          <Switch>
            <Route path="/home" component={() => <Home />} />
            <Route exact path="/menu" component={() => <Dishes />} />
            <Route path="/menu/:id" component={DishDetail} />
            <Route path="/about" component={About} />
            <Route path="/gallery" component={Gallery} />
            <Route path="/contact" component={Contact} />
            <Redirect to="/home" />
          </Switch>
          <Footer />
        </main>
      </Router>
    </AppProvider>
  );
}

export default App;
